import React, { Component } from 'react';
import Header from '../Header/Header';
import { Link, Redirect } from 'react-router-dom';
import axios from 'axios';
import Moment from 'moment';
import baseUrl from '../baseUrl';

// const baseUrl = "http://api.encabook999.com:4000";
class Receive extends Component {
  constructor(props) {
    super(props);
    var accessToken = localStorage.getItem('token');
    var user_id = localStorage.getItem('user_id');
    var user_Type = localStorage.getItem('user_Type');
    this.state = {
      accessToken: accessToken,
      tabledata: '',
      respStatus: false,
      user_id: user_id,
      user_Type: user_Type,
    };
  }
  componentWillMount() {
    let headers = {
      Authorization: 'Bearer ' + this.state.accessToken,
    };
    if (this.state.user_Type == 1) {
      axios.get(baseUrl + '/alluserbetlist', { headers }).then((resp) => {
        var respNew = resp.data;
        if (respNew.success === true) {
          this.setState({
            tabledata: respNew.Betlist,
            respStatus: respNew.success,
          });
        }
      });
    } else {
      axios.get(baseUrl + '/userbetlist', { headers }).then((resp) => {
        var respNew = resp.data;
        if (respNew.success === true) {
          this.setState({
            tabledata: respNew.Betlist,
            respStatus: respNew.success,
          });
        }
      });
    }
  }
  showTableHtml = () => {
    if (this.state.respStatus === true) {
      const html = [];
      this.state.tabledata.map(function (value, i) {
        if (value.eventTypeId == 4) {
          event = 'Cricket';
        }
        if (value.eventTypeId == 1) {
          event = 'Football';
        }
        if (value.eventTypeId == 2) {
          event = 'Tennis';
        }
        if (value.eventTypeId == 7) {
          event = 'Horse Riding';
        }
        html.push(
          <tr>
            <td>{i + 1}</td>
            <td>{event}</td>
            <td>{value.eventName}</td>
            <td>{value.teamname}</td>
            <td>{value.BatAmount}</td>
            <td>{value.profitvalue}</td>
            <td>{Moment(value.created_at).format('lll')}</td>
          </tr>
        );
      });
      return <tbody>{html}</tbody>;
    }
  };
  render() {
    var accessToken = this.state.accessToken;
    if (accessToken === '' || accessToken === null) {
      return <Redirect to="/login" />;
    }
    var change_password = localStorage.getItem('change_password');

    if (change_password == 2 && change_password != null) {
      return <Redirect to="/changepass" />;
    }

    return (
      <div>
        <Header />
        <div id="page-wrapper">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="page-header">User Bet List</h1>
              {/* <a href="/fancybetadd"><button type="button" className="btn btn-info">ADD</button></a>  */}
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-lg-12 col-md-12 table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Event Type</th>
                    <th>Match Name</th>
                    <th>Team </th>
                    <th>Bet Amount</th>
                    <th>Profit Amount</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                {this.showTableHtml()}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Receive;



// WEBPACK FOOTER //
// ./src/components/Admin/userbetlist.js